export default $wire => ({
    isOpen: false,

    open() {
        this.isOpen = true;
    },
});
